module.exports = __webpack_public_path__ + "img/mac.b699e767.png";